import React, { useEffect, useState } from 'react'
import { CForm, CFormCheck, CFormInput, CFormLabel, CRow } from '@coreui/react';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Slider } from 'primereact/slider';
import { Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useTable } from '../contexts/TableContext'
import CInput from './CInput';

function AddTable({ editTableId, tableCreateVisible, floorId, stageSize, tableShapeProperties, setTableShapeProperties, fetchSingleFloor, setEditTableId, canCreate, canUpdate, canDelete }) {
    const { getSingleTable, createTable, updateTable, deleteTable } = useTable()
    const { toast, restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);

    useEffect(() => {
        if (editTableId) {
            fetchSingleTable();
        }
    }, [editTableId]);

    const fetchSingleTable = async () => {
        try {
            const data = await getSingleTable(editTableId);
            setTableShapeProperties(data);
        } catch (error) {
            console.error('Error fetching single table:', error);
        }
    };

    const handleClose = () => {
        setTableShapeProperties({
            width: 150,
            height: 150,
            rotation: null,
            color: null,
            name: '',
            shape: 'circle',
            x: null,
            y: null,
            chairs: '',
            size: 'regular'
        })
        fetchSingleFloor()
        setValidated(false)
        setEditTableId(null)
    }

    const generateShape = async (e) => {
        e.preventDefault()
        
        if((!editTableId && !canCreate) || (editTableId && !canUpdate)) return;

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (tableCreateVisible && floorId) {
                    const data = await createTable({ ...tableShapeProperties, floor_id: floorId })
                    if (!data.error) {
                        handleClose()
                    }
                } else if (editTableId && floorId) {
                    const data = await updateTable(editTableId, { ...tableShapeProperties, floor_id: floorId })
                    if (!data.error) {
                        setTimeout(function () {
                            toast.current?.show({ severity: 'success', summary: 'Table', detail: data.message, life: 3000 })
                        }, 500);
                        handleClose()
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Table', detail: data.message, life: 3000 })
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    };

    const handleDelete = async () => {
        try {
            const confirmed = await confirmDelete();

            if (confirmed) {
                await deleteTable(editTableId);
                handleClose();
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    };

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to delete table?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };

    return (
        <div>
            <ConfirmDialog />
            {
                ((tableCreateVisible || editTableId) && restaurantId) &&
                (
                    <div className='add-table'>
                        <CForm onSubmit={generateShape} noValidate validated={validated}>
                            <CInput
                                className='mb-3 mt-3'
                                type={'text'}
                                label={'Name'}
                                required={true}
                                value={tableShapeProperties.name}
                                onChange={(value) => setTableShapeProperties({ ...tableShapeProperties, name: value })}
                                errorMessage='Name is required.'
                            />
                            <div className='mb-3 mt-3'>
                                <CFormLabel>Person per table <span className="text-danger">*</span></CFormLabel>
                                <CFormInput
                                    type="text"
                                    value={tableShapeProperties.chairs}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        const numericValue = inputValue.replace(/[^\d+]/g, '');
                                        setTableShapeProperties({ ...tableShapeProperties, chairs: numericValue });
                                    }}
                                    feedbackInvalid='Number of person is required.'
                                    required={true}
                                />
                            </div>
                            {/* <CRow>
                                <div className='mb-3'>
                                    <CFormLabel className="form-label w-55">Width <span className="text-danger">*</span></CFormLabel>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        min={50}
                                        value={tableShapeProperties.width}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue > 0) {
                                                setTableShapeProperties({ ...tableShapeProperties, width: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Please enter valid width.'
                                    />
                                </div>
                            </CRow>
                            <CRow>
                                <div className='mb-3'>
                                    <CFormLabel className="form-label w-55">Height <span className="text-danger">*</span></CFormLabel>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        min={50}
                                        value={tableShapeProperties.height}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue > 0) {
                                                setTableShapeProperties({ ...tableShapeProperties, height: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Please enter valid height.'
                                    />
                                </div>
                            </CRow>
                            <CRow className='mb-3'>
                                <div>
                                    <div className='d-flex mb-2'>
                                        <CFormLabel>Rotation</CFormLabel> <span className='rotations'>{tableShapeProperties.rotation}</span>
                                    </div>
                                    <div>
                                        <Slider
                                            value={tableShapeProperties.rotation}
                                            onChange={(e) => setTableShapeProperties({ ...tableShapeProperties, rotation: e.value })}
                                            max={360}
                                        />
                                    </div>
                                </div>
                            </CRow>
                            <CRow className='mb-3'>
                                <CInput
                                    type={'color'}
                                    label={'Colour'}
                                    value={tableShapeProperties.color}
                                    onChange={(value) => setTableShapeProperties({ ...tableShapeProperties, color: value })}
                                />
                            </CRow> */}
                            <CRow className="mb-3">
                                <div>
                                    <CFormLabel>Size <span className="text-danger">*</span></CFormLabel>
                                    <CFormCheck
                                        type="radio"
                                        name="sizeOptions"
                                        id="sizeSmall"
                                        value="small"
                                        checked={tableShapeProperties.size === 'small'}
                                        onChange={() => setTableShapeProperties({ ...tableShapeProperties, size: 'small' })}
                                        label="Small"
                                    />
                                    <CFormCheck
                                        type="radio"
                                        name="sizeOptions"
                                        id="sizeRegular"
                                        value="regular"
                                        checked={tableShapeProperties.size === 'regular'}
                                        onChange={() => setTableShapeProperties({ ...tableShapeProperties, size: 'regular' })}
                                        label="Regular"
                                    />
                                </div>
                            </CRow>
                            <CRow className="mb-2">
                                <div>
                                    <CFormLabel>Shape <span className="text-danger">*</span></CFormLabel>
                                    <CFormCheck
                                        type="radio"
                                        name="shapeOptions"
                                        id="shapeCircle"
                                        value="circle"
                                        checked={tableShapeProperties.shape === 'circle'}
                                        onChange={() => setTableShapeProperties({ ...tableShapeProperties, shape: 'circle' })}
                                        label="Circle"
                                    />
                                    <CFormCheck
                                        type="radio"
                                        name="shapeOptions"
                                        id="shapeSquare"
                                        value="square"
                                        checked={tableShapeProperties.shape === 'square'}
                                        onChange={() => setTableShapeProperties({ ...tableShapeProperties, shape: 'square' })}
                                        label="Square"
                                    />
                                    <CFormCheck
                                        type="radio"
                                        name="shapeOptions"
                                        id="shapeRectangle"
                                        value="rectangle"
                                        checked={tableShapeProperties.shape === 'rectangle'}
                                        onChange={() => setTableShapeProperties({ ...tableShapeProperties, shape: 'rectangle' })}
                                        label="Rectangle"
                                    />
                                </div>
                            </CRow>
                            {((!editTableId && canCreate) || (editTableId && canUpdate)) && 
                                <Button fullWidth variant="contained" color='info' type="submit" className='mt-3'>
                                    Submit
                                </Button>
                            }
                        </CForm>
                        {
                            (editTableId && canDelete) && (
                                <Button fullWidth variant="contained" color='error' type="submit" className='mt-3' onClick={handleDelete}>
                                    Delete
                                </Button>
                            )
                        }
                    </div>
                )
            }
        </div>
    )
}

export default AddTable